export default {"src":"/_next/static/media/circle.145d989b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};